<template>
    <b-modal :active.sync="localActive" :width="1200"
         has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog" aria-modal custom-class="center-always-modal wide-summary-modal">
        <div class="modal-card" style="width: auto;">
            <header class="modal-card-head has-background-white pb-0 is-align-items-center" style="border-bottom: none;">
                <p class="modal-card-title tittleBodyModal mb-1 has-text-weight-bold" style="color: #101828; font-size: 18px;">Resumen de Clasificación</p>
                <button type="button" class="delete" aria-label="close" @click="localActive = false"/>
            </header>
            <section class="modal-card-body px-5 pb-5 pt-1">
                <div class="is-flex is-justify-content-flex-end mb-4">
                    <div class="button_tipo_contraparte mr-4">
                        <div style="min-width: 180px">
                            <SelectComponent v-model="localSelectedType" label="Tipo Contraparte" :weirdOptions="null"
                                :options="typeOptions" />
                        </div>
                    </div>
                    <div class="button_tipo_contraparte">
                        <div style="width: 230px">
                            <SelectComponent v-model="localSelectedRange" currentIcon="calendar" label="Rango de tiempo"
                                :options="periodDataSelect" :weirdOptions="null" />
                        </div>
                    </div>
                </div>
                <div class="columns is-variable is-1 mt-2 pt-1">
                    <div class="column">
                        <CardResumeClassification class="pie_chart_box" tittleCard="Contrapartes"
                            :periodUsed="selectedPeriodCounterparts.label" :counterpartUsed="selectedCounterpartObject.label"
                            :progress="dataCounterparts.progress" :classified="dataCounterparts.classified"
                            :notClassified="dataCounterparts.notClassified" />
                    </div>
                    <div class="column">
                        <CardResumeClassification class="pie_chart_box" tittleCard="Documentos"
                            :counterpartUsed="selectedCounterpartObject.label" :periodUsed="selectedPeriodCounterparts.label"
                            :progress="dataDocuments.progress" :classified="dataDocuments.classified"
                            :notClassified="dataDocuments.notClassified" />
                    </div>
                    <div class="column">
                        <CardResumeClassification class="pie_chart_box"
                            :tittleCard="localSelectedType == 'Cliente' ? 'Ingresos' : 'Egresos'"
                            :counterpartUsed="selectedCounterpartObject.label" :periodUsed="selectedPeriodCounterparts.label"
                            :progress="dataExpenses.progress" :classified="dataExpenses.classified" :isMoney="true"
                            :notClassified="dataExpenses.notClassified" />
                    </div>
                </div>
                <div class="dismiss_today_row mt-5 pt-4">
                    <button type="button" class="dismiss_today_btn" @click="dismissForToday">
                        No volver a mostrar hoy
                        <svg class="dismiss_today_icon" width="16" height="16" viewBox="0 0 24 24"
                             fill="none" stroke="currentColor" stroke-width="2.5"
                             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                    </button>
                </div>
            </section>
        </div>
    </b-modal>
</template>

<script>
import SelectComponent from "@/components/classification/SelectComponent";
import CardResumeClassification from "@/components/classification/CardResumeClassification";
import { mapState, mapActions } from "vuex";
import { dismissUntilEndOfDay } from "@/utils/modalDismissal";

const DISMISS_ID = "resumeClassification";

export default {
    name: "ResumeClassificationModal",
    components: {
        SelectComponent,
        CardResumeClassification
    },
    props: {
        active: {
            type: Boolean,
            default: false
        },
        typeOptions: {
            type: Array,
            default: () => []
        },
        periodDataSelect: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState("classification", ["selectedType", "selectedRange", "selectedPeriodCounterparts",
            "selectedCounterpartObject", "dataCounterparts", "dataDocuments", "dataExpenses"]),
        localActive: {
            get() {
                return this.active;
            },
            set(value) {
                this.$emit("update:active", value);
            }
        },
        localSelectedType: {
            get() {
                return this.selectedType;
            },
            set(value) {
                const optionSelected = this.typeOptions.find((o) => o.value == value);
                this.updateSelectedType(optionSelected);
                this.$emit("reloadCounterpart");
            }
        },
        localSelectedRange: {
            get() {
                return this.selectedRange;
            },
            set(value) {
                const optionSelected = this.periodDataSelect.find((o) => o.value == value);
                this.setSelectedPeriodCounterparts(optionSelected);
                this.$emit("reloadCounterpart");
            }
        }
    },
    methods: {
        ...mapActions("classification", ["updateSelectedType", "setSelectedPeriodCounterparts"]),
        // Affirmative action: persiste el dismissal hasta fin de día y cierra
        // el modal en un solo gesto. El caller (componente padre que abre el
        // modal) lee `isDismissedUntilEndOfDay` antes de re-abrirlo durante
        // el día, por eso acá sólo escribimos — no leemos al abrir.
        dismissForToday() {
            dismissUntilEndOfDay(DISMISS_ID);
            this.localActive = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.pie_chart_box {
    border: 1px solid #EAECF0;
    border-radius: 6px;
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.button_tipo_contraparte {
    display: flex;
    flex-direction: column;
    align-items: left;
}

.tittleBodyModal {
    color: #101828;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
}

.dismiss_today_row {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--report-border, #EAECF0);
}

// Botón "No volver a mostrar hoy" — secondary affirmative action.
// Pertenece a la familia cromática cyan/teal del módulo classification
// (mismo accent-bg que el bullet "Clasificados" del CardResumeClassification).
// Whisper-quiet shadow + border accent suave para que no compita con las
// cards de chart de arriba.
.dismiss_today_btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: 1px solid var(--report-accent-border, #aaf1f7);
    border-radius: 8px;
    background-color: var(--report-accent-bg, #edfdfe);
    color: var(--report-accent-text, #157389);
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
    transition: background-color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

    &:hover {
        // Intensifica levemente el accent — feedback whisper-quiet, no jarring.
        background-color: #d6f7fa;
        border-color: #87e7ef;
    }

    &:active {
        transform: translateY(1px);
    }

    &:focus-visible {
        outline: 2px solid var(--report-accent-text, #157389);
        outline-offset: 2px;
    }
}

.dismiss_today_icon {
    flex-shrink: 0;
}
</style>

<style>
.wide-summary-modal .animation-content, .wide-summary-modal .modal-card {
    width: 1200px !important;
    max-width: 95vw !important;
}
</style>
